import { ReactNode } from "react";
import { authErrorLabels } from "src/components/page-components/AuthPages/authPageErrors";
import { readCookie } from "src/utils/cookies/cookies";
import { IncomingMessage } from "http";
import { cookieRefresh, cookieUser } from "src/utils/cognito/constants";

export class AuthError extends Error {
  code: string;
  label: ReactNode;

  constructor(code: string) {
    super(code);
    this.name = `AuthError(${code})`;
    this.code = code;
    this.label =
      authErrorLabels[code] ??
      "Something went wrong. Refresh the page and try again.";
  }
}

// Parse an allowlist of error messages into a code of our liking
// This should be used in cases where a given error code is too broad
// to show something meaningful to the user
// When adding an error here make sure to add it to `authErrorLabels` in
// src/components/page-components/AuthPages/authPageErrors.tsx
export function errCodeFromMessage(msg: string): string | undefined {
  const hashMap = {
    // The error code this error gets returned in is InvalidParameterException
    // which is too broad to handle generically so check the message
    "no registered/verified email": "EmailNotVerified",
    "User is already confirmed": "UserAlreadyConfirmed",
    "Current status is CONFIRMED": "UserAlreadyConfirmed",
  };
  for (const [key, value] of Object.entries(hashMap)) {
    if (msg.includes(key)) {
      return value;
    }
  }
}

// Check if a request has auth cookies to see if the user is probably logged in.
// This does not check if the cookies are valid, just that they are present.
export const hasAuthCookies = (req: IncomingMessage) => {
  return (
    Boolean(readCookie(req, cookieRefresh)) &&
    Boolean(readCookie(req, cookieUser))
  );
};
